import * as Sentry from '@sentry/react'
import { API_BASE_URL, X_API_KEY } from './api'

export const viewLibertin = async (announceId: number) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/libertin/${announceId}/view`,
      {
        method: 'GET',
        headers: {
          'x-api-key': X_API_KEY,
        },
      },
    )
    if (!response.ok) {
      throw new Error('Network response was not ok')
    }
    return response.json()
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        action: 'viewLibertin',
        announceId,
        timestamp: new Date().toISOString(),
      },
      tags: {
        type: 'api_error',
        method: 'viewLibertin',
      },
    })
    throw error
  }
}
